///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ChangeDetectionStrategy, Component, OnInit, Signal } from '@angular/core';
import { FoldersTreeService, FolderTreeNode } from './folders-tree.service';
import { ProjectDragAndDropService } from '../project-drag-and-drop.service';
import { ProjectFolderEnum } from '../../generated/shared-types.model';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { SuiSvgIconComponent } from '@siklu/sui-lib';
import { ButtonsDirectivesModule } from '../../shared/directives/buttons-directives/buttons-directives.module';
import { DragDropModule } from '@angular/cdk/drag-drop';

@Component({
    selector: 'winde-folders-tree',
    templateUrl: './folders-tree.component.html',
    styleUrls: ['./folders-tree.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgTemplateOutlet, NgClass, DragDropModule, SuiSvgIconComponent, ButtonsDirectivesModule]
})
export class FoldersTreeComponent implements OnInit {
    public tree: Signal<FolderTreeNode[]>;

    private drugOverFolderId: number;

    constructor(
        public readonly projectDragAndDropService: ProjectDragAndDropService,
        private readonly foldersTreeService: FoldersTreeService
    ) {}

    ngOnInit(): void {
        this.tree = this.foldersTreeService.getTree();
    }

    public selectFolder(folder: FolderTreeNode) {
        this.foldersTreeService.selectFolder(folder.id);
    }

    public toggleOpen(folder: FolderTreeNode) {
        this.foldersTreeService.toggleOpen(folder.id);
    }

    public dragOver(folder?: FolderTreeNode) {
        if (folder && !folder.parentId && folder.type === ProjectFolderEnum.BUG_REPORT) {
            return;
        }

        this.drugOverFolderId = folder?.id;
        this.projectDragAndDropService.setOpenFolderTimer(this.drugOverFolderId, () => {
            this.selectFolder(folder);
            this.toggleOpen(folder);
        });
    }
}
